
export default {
  props: {
    rowItem: {
      type: Object,
      default: () => {},
    },
    id: {
      type: Number,
      required: true,
    },
  },
}
